import request from '@/utils/request'


export function save(description) {
  return request({
    url: 'administration/category/save',
    method: 'post',
    data: { description }
  });
}

export function update(id,description) {
  return request({
    url: 'administration/category/update',
    method: 'put',
    data: { id, description }
  });
}

export function getAllCategory() {
  return request({
    url: 'administration/getAllCategory',
    method: 'get',
  });
}

export function getByIdCategory(id) {
  return request({
    url: 'administration/category/getById/'+id,
    method: 'get',
  });
}

export function destroy(id) {
  return request({
    url: 'administration/category/destroy/' + id,
    method: 'delete',
  });
}
